import { Users } from "lucide-react";
import OrgNode from "../Components/orgNode";
import UnassignedList from "../Components/unAssignedList";
import { useUserManagementViewModel } from "../viewModel/userManagement.viewmodel";

export const HirearchyView = () => {
  const { state } = useUserManagementViewModel();

  return (
    <div className="min-h-screen bg-gray-50 px-2 sm:px-6 py-6 sm:py-2">
      <div className="w-full lg:max-w-screen-xl lg:mx-auto space-y-6">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-800">Team Hierarchy</h1>

          <p className="mt-2 flex items-start justify-center gap-2 text-gray-500 text-sm sm:text-base text-center flex-wrap">
            <Users size={16} className="mt-1 shrink-0" />
            {state.teamHierarchy.total_employees} employees
          </p>
        </div>

        {/* Org Chart Card */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 sm:p-4 w-full">
          <h2 className="text-lg font-semibold text-gray-700 mb-6">
            Organization Structure
          </h2>

          <div className="overflow-x-auto  py-6">
            <div className="flex min-w-max  gap-6">
              {state.teamHierarchy.org_chart.map((root) => (
                <OrgNode key={root.id} member={root} isRoot />
              ))}
            </div>
          </div>
        </div>
        {/* Unassigned */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6">
          {" "}
          <h2 className="text-lg font-semibold text-gray-700 mb-4">
            {" "}
            Unassigned Employees{" "}
          </h2>{" "}
          <UnassignedList employees={state.teamHierarchy.unassigned} />{" "}
        </div>
        {/* <UnassignedList employees={state.teamHierarchy.unassigned} /> */}
      </div>
    </div>
  );
};
